import { FC } from "react";
import Icon from "../Icon";
import { Text } from "../Text";

export type PasswordFieldTooltipProps = {
  password: string;
}

export const PasswordFieldTooltip: FC<PasswordFieldTooltipProps> = ({ password }) => {
  const has8Characters = password.length > 7;
  const hasUppercaseLetter = password.match(/[A-Z]/);
  const hasNumber = password.match(/[0-9]/);

  return password && (
    <div className="relative md:absolute z-1 top-[10px] left-[calc(100%+8px)] w-2xs bg-gray-900 rounded-10 p-s text-white gap-s
    before:content-[''] before:absolute before:top-[calc(50%-8px)] before:left-[-16px] before:w-0 before:h-0 before:border-[8px] before:border-transparent before:border-r-blue-900 before:z-1]">
      <Text type="caption2" className="text-white mb-3xs">Password requirements:</Text>
      <ul className="space-y-3xs">
        <li className="flex items-center gap-2xs">
          {has8Characters ?
            <Icon name="check" size={12} type="filled" className="text-green-500" />
            :
            <Icon name="x-close" size={12} type="filled" className="text-red-500" />
          }
          <Text type="caption2" className="text-white"> 8 characters</Text>
        </li>
        <li className="flex items-center gap-2xs">
          {hasUppercaseLetter ?
            <Icon name="check" size={12} type="filled" className="text-green-500" />
            :
            <Icon name="x-close" size={12} type="filled" className="text-red-500" />
          }
          <Text type="caption2" className="text-white"> 1 uppercase letter</Text>
        </li>
        <li className="flex items-center gap-2xs">
          {hasNumber ?
            <Icon name="check" size={12} type="filled" className="text-green-500" />
            :
            <Icon name="x-close" size={12} type="filled" className="text-red-500" />
          }
          <Text type="caption2" className="text-white"> 1 number</Text>
        </li>
      </ul>
    </div>
  );
};
